/* Map of known origins to their corresponding product page origins */
const originMap = {
  'www.garmin.com': 'https://www.garmin.com',
  'wwwpub.garmin.com': 'https://wwwpub.garmin.com',
  'www.dev.garmin.com': 'https://www.dev.garmin.com',
  'localhost.garmin.com': 'https://www.dev.garmin.com',
  'product-compare.pre.dev': 'https://product-pages.pre.dev.cv1.garmin.com',
  'product-compare.pre.prod.cv1': 'https://product-pages.pre.prod.cv1.garmin.com',
  'product-compare.pre.prod.kc3': 'https://product-pages.pre.prod.kc3.garmin.com',
};

// If origin includes keys from originMap, use the corresponding value; otherwise, use 'https://www.garmin.com'
export const getProductPageOrigin = (origin) => Object.entries(originMap)
  .find(([originKey]) => origin.includes(originKey))?.[1] || 'https://www.garmin.com';

export default getProductPageOrigin;
